import { render, staticRenderFns } from "./ManageColumns.vue?vue&type=template&id=65f6dbab&scoped=true"
import script from "./ManageColumns.vue?vue&type=script&lang=js"
export * from "./ManageColumns.vue?vue&type=script&lang=js"
import style0 from "./ManageColumns.vue?vue&type=style&index=0&id=65f6dbab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f6dbab",
  null
  
)

export default component.exports